<template>
  <div class="container-fluid p-0 m-0">

    <!-- pop -->
    <div v-if="isdelete" class="pop-bg">
      <div class="pop-box">
        <h3>確定刪除?</h3>
        <button type="button" @click="doDelete()" class="btn btn-secondary mt-4 mx-4">{{$t('confirm')}}</button>
        <button type="button" @click="isdelete=false"  class="btn btn-secondary mt-4 mx-4">{{$t('cancel')}}</button>
      </div>
    </div>

    <div v-if="addSence" class="pop-bg">
      <div class="pop-box">
        <h3>新增場景</h3>
        <input v-model="senceName" class="form-control">
        <button type="button" @click="addNewSence" class="btn btn-secondary mt-4 mx-4">{{$t('confirm')}}</button>
        <button type="button" @click="addSence=false" class="btn btn-secondary mt-4 mx-4">{{$t('cancel')}}</button>
      </div>
    </div>

    <!-- navbar -->
    <nav class="navbar navbar-dark fixed-top justify-content-between">
      <div class="d-flex">
        <router-link class="navbar-brand m-0" :to="{ name:'home' }">LiveABC</router-link>
        <ul class="d-flex my-auto" style="color:white;list-style:none;">
          <li class="mx-2 nav-btn" :class="{'active':currentMenu ===  $t('exam_list')}"  @click="goMenu">{{$t('exam_list')}}</li>
          <li class="mx-2 nav-btn" :class="{'active':currentMenu ===  $t('720_editor')}"  @click="goMenu">{{$t('720_editor')}}</li>
          <li class="mx-2 nav-btn" @click="goMenu">{{$t('logout')}}</li>
        </ul>
      </div>
      <a class="navbar-brand rwd-hide m-0" href="#">{{$t('welcome')}} {{username}}</a>
    </nav>
    <div class="row mt-5 no-gutters" style="height:100%;background-color: #f7f7f7;">
      <exam-modify v-if="this.$route.params.id" />
      <div class="col-10 m-auto mofify-body" v-else>
        <div class="exam-list" v-if="currentMenu === $t('exam_list')">
          <div style="text-align: left;">
            <button class="btn btn btn-outline-secondary mr-2" @click="goMenu">{{$t('add_exam')}}</button>
            <label class="btn btn-outline-secondary m-0">
            <input id="fileUpload" style="display:none" @change="fileUpload" accept=".json" type="file">
              {{$t('import_exam')}}
            </label>
          </div>
          <!-- 列表 -->
          <ul class="list-group">
            <li class="list-group-item my-2" v-for="(exam , num) in examData" :key="num">
              <div class="d-flex justify-content-between align-items-center">
                  {{$t('exam_name')}}:{{exam['exam'].name||'defult'}}
                <div class="m-0 rwd-hide">
                  {{num}}
                  <button class="copy-btn ml-3" style="float: right;border: none;" :data-clipboard-text="num" @click="copy()">{{$t('copy')}}</button>
                </div>
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-secondary" @click="$router.push({name: 'exam.editor', params: { id: num }})">{{$t('modify')}}</button>
                  <button type="button" class="btn btn-secondary" @click="remove(num)" >{{$t('delete')}}</button>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- 新增 -->
        <div class="exam-create" v-if="(currentMenu === $t('add_exam'))">
          <div class="create-title mt-4">
            <div class="form-group">
              <label>{{$t('exam_name')}}:</label>
              <input class="form-control question-group" type="text" :change="inputCheck(exam.name)" :placeholder="$t('fillIn_name')" v-model="exam.name" >
              <span class="callout">
                Only letters, numbers, underscores (_) are allowed!
              </span>
            </div>
            <button @click="createExam">新增</button>
          </div>
        </div>
        <!-- 720編輯器 -->
        <div class="tagEditor" style="min-height:100vh" v-show="currentMenu === $t('720_editor')">
          <div class="p-4" style="text-align: left;">
            <button type="button" @click="addSence = true" class="btn btn-outline-secondary">Add sence</button>
            <ul class="list-group">
              <li style="padding: 0 5px" class="list-group-item my-2" v-for="(item , index) in list" :key="index">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex" style="height:60px">
                    <img style=" width:auto;height:auto;max-width:100%;max-height:100%;" :src="item.thumbnail" alt="">
                    <p class="m-auto pl-3">
                      {{item.name}}
                    </p>
                  </div>
                  <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button"  @click="$router.push({name: 'viewer', params: { id: item.buildingId }})" class="btn btn-secondary">{{$t('demo')}}</button>
                    <button type="button" @click="setIframe(item)" class="btn btn-secondary">{{$t('modify')}}</button>
                    <button type="button" @click="deleteSence(item)" class="btn btn-secondary">{{$t('delete')}}</button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api.js'
import axios from '../store/api'
import Clipboard from 'clipboard'
import ExamModify from './ExamModify'
export default {
  name: 'ExamEditor',
  mixins: [api],
  components: {
    ExamModify
  },
  data () {
    return {
      isdelete: false,
      addSence: false,
      deleteNum: '',
      username: '',
      senceName: '',
      currentMenu: '',
      list: [],
      senceId: '',
      examData: null,
      exam: {
        name: '',
        practices: [
          {
            'sort': 0,
            'title': '',
            'answers': [],
            'items': [
              '',
              '',
              '',
              ''
            ],
            'examType': 'single'
          }
        ]
      }
    }
  },
  beforeMount () {
    this.bus.$on('prevous', (data) => {
      this.currentMenu = data
    })
  },
  mounted () {
    this.currentMenu = this.currentMenu ? this.currentMenu : this.$t('exam_list')
    const vm = this
    if (window.localStorage.getItem('login')) {
      this.getAll()
      this.username = JSON.parse(window.localStorage.getItem('login')).username
    } else {
      vm.$router.replace({
        name: 'login'
      })
    }
    this.getScenesList()
  },
  methods: {
    inputCheck (name) {
      if (name) { this.exam.name = this.exam.name.replace(/[^\w_]/g, '') }
    },
    goMenu (e) {
      this.currentMenu = e.target.textContent
      this.resetPosition()
      switch (e.target.textContent) {
        case this.$t('add_exam'):
          this.exam.name = ''
          this.currentMenu = e.target.textContent
          break
        case this.$t('exam_list'):
          this.$router.push({ name: 'exam.editor' })
          break
        case this.$t('720_editor'):
          this.$router.push({ name: 'exam.editor' })
          break
        default:
          this.$store.state.token = ''
          localStorage.removeItem('login')
          this.$router.push({ name: 'login' })
      }
    },
    getScenesList () {
      const user = JSON.parse(window.localStorage.getItem('login'))
      axios.get(`https://api.liveabc.com/v1/720vr/${user.username}`).then((data) => {
        this.list = data.data || []
      })
    },
    addNewSence () {
      const user = JSON.parse(window.localStorage.getItem('login'))
      const config = {
        headers: {
          'iStaging-Token': user.token
        }
      }
      const senceData = {
        'name': this.senceName,
        'unavailable': true
      }
      axios.post(`https://vrcam-prod-api.istaging.com/api/v2/buildings`, senceData, config).then((data) => {
        console.log(data)
        this.getScenesList()
        this.addSence = false
      })
    },
    deleteSence (item) {
      const user = JSON.parse(window.localStorage.getItem('login'))
      console.log(item)
      const config = {
        headers: {
          'iStaging-Token': user.token
        },
        data: {
          'buildings': [
            item.buildingId
          ]
        }
      }
      axios.delete(`https://vrcam-prod-api.istaging.com/api/v2/buildings`, config).then((data) => {
        console.log(data)
        this.getScenesList()
      })
    },
    setIframe (item) {
      this.senceId = item.buildingId
      this.$router.push({ name: 'vr.editor', params: { id: item.buildingId } })
    },
    copy () {
      var clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        alert('copy')
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        alert('該瀏覽器不支持自動複製')
        clipboard.destroy()
      })
    },
    remove (num) {
      this.isdelete = true
      this.deleteNum = num
    },
    doDelete () {
      this.isdelete = false
      this.removeExam(this.deleteNum)
    },
    resetPosition () {
      window.document.body.scrollTop = 0
      window.document.documentElement.scrollTop = 0
    },
    createExam () {
      let num = this.addExam(this.exam)
      this.$router.push({ name: 'exam.editor', params: { id: num } })
      this.currentMenu = this.$t('exam_list')
    },
    fileUpload (e) {
      let vm = this
      let formData = new FormData()
      formData.append('file', e.target.files[0])
      console.log(e.target.files[0])
      const reader = new FileReader()
      reader.onload = (function (theFile) {
        return function (e) {
          console.log(JSON.parse(e.target.result))
          let data = JSON.parse(e.target.result)
          vm.addExam(data)
        }
      })()
      reader.readAsText(e.target.files[0])
      this.getAll()
      let file = document.getElementById('fileUpload')
      file.value = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .navbar {
    background-color: #000;
    box-shadow: 0 0 15px #2e2e2e;
  }
  li {
    text-align: left;
  }
  .nav-btn {
    cursor: pointer;
    color: #fff;
    list-style:none;
  }

  .active {
    // text-shadow: 0.2em 0.2em 0.5em black;
    text-shadow: 0 0 0.2em rgb(182, 182, 182), 0 0 0.2em rgb(182, 182, 182),
      0 0 0.2em rgb(182, 182, 182)
  }
  .question-group {
    height: 60px;
    font-size: 1.25rem;
  }
  .question-group:focus {
    transform: scale(1.02);
    transition: transform 200ms linear;
  }
  .exam-list,.exam-create  {
    min-height: 100vh;
    font-size: 1.25rem;
    padding: 20px 20px;
  }
  .mofify-body {
    background-color: #f7f7f7;
    padding: 0 !important;

  }
  .list-group-item {
    border-radius: 10px;
  }
  .list-group-item:hover {
    transform: scale(1.03);
    transition: transform 200ms linear;
  }
  .question-amount {
    text-align: left;
  }
  .pop-bg {
    position: fixed;
    z-index: 4;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .pop-box {
    border-radius: 10px;
    width: 30%;
    min-height: 30%;
    padding: 3%;
    margin-top: 10%;
    margin-left: 35%;
    background-color: #fff;
  }
  .callout {
    left: 15px;
  }
</style>
